<template>
  <gj-select 
    v-bind="$attrs"
    v-on="$listeners"
    ref="addSelect"
    type="add-select">
    <div class="gj-add-select-content">
      <el-option-group
        class="search-group"
        key="search-group">
        <el-option value="-1">
          <div class="multi-check--input" @click.stop="addOptions">
            <i class="el-icon-plus"></i> 添加
          </div>
        </el-option>
      </el-option-group>
      <el-option-group
        class="select-group"
        :class="{'select-group-empty': (!options || options.length == 0)}"
        key="select-group">
        <template v-if="options && options.length != 0">
          <template v-for="item in options">
            <el-option
                class="select-option"
                :key="item[idMap]"
                :label="item[labelMap]"
                :value="item[idMap]">
            </el-option>
          </template>
        </template>
        <template v-else>
          <div class="dropdown-empty"> 无匹配数据 </div>
        </template>
      </el-option-group>
    </div>
  </gj-select>
</template>

<script>
export default {
  name: "gj-add-select",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    idMap: {
      type: String,
      default: "id"
    },
    labelMap: {
      type: String,
      default: "text"
    }
  },
  methods: {
    // 添加
    addOptions() {
      this.$refs.addSelect.$refs.select.visible = false
      this.$emit("addOptions")
    }
  }
};
</script>

<style scoped lang="scss">
.multi-check--input {
  border: 1px solid #ccc;
  line-height: 1;
  padding: 6px 60px;
  margin: 0 15px;
  border-radius: 3px;
  color: #969696;
  &:hover {
    color: #1F6EEF;
    border-color: #1F6EEF;
  }
}
.search-group {
  padding-bottom: 20px;
  /deep/.el-select-dropdown__item {
    background: #fff !important;
  }
}
/deep/.el-select-dropdown__item {
  padding: 0;
  // background: #fff !important;
}
.gj-add-select-content {
  // display: flex;
  // flex-direction: column;
}
.select-group {
  display: block !important;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 6px;
  height: 150px;
  .dropdown-empty {
    color: #999;
    font-size: 12px;
    text-align: center;
  }
  &.select-group-empty {
    height: 50px;
  }
}
.select-option {
  padding: 0 12px;
}
</style>